import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { SortDirection } from "@enums/SortDirection";
import { SortType } from "@enums/SortType";
import { VeriDate } from "@services/veriDate.service";

@Pipe({ name: 'orderByProp' })
@Injectable()
export class OrderByPropPipe implements PipeTransform {
    constructor(private veriDate: VeriDate) { }

    transform(data: any[], property: string, sortType: SortType = SortType.String, ascending: boolean = true): any[] {

        if (!data.length) {
            return [];
        }

        const dataCopy = [...data];

        if (!property) {
            return dataCopy;
        }

        const sortDirection = (ascending) ? SortDirection.Ascending : SortDirection.Descending;

        return dataCopy.sort((data1, data2) => {
            if (!data1[property] || !data2[property]) {
                return 0;
            }

            return this.getSortResponse(data1[property], data2[property], sortType, sortDirection);
        });
    }

    private getSortResponse(data1: any, data2: any, sortType: SortType, sortDirection: SortDirection): number {
        if (data1 == data2) {
            return 0;
        }
        else if (data1 == null) {
            return sortDirection === SortDirection.Ascending ? -1 : 1
        }
        else if (data2 == null) {
            return sortDirection === SortDirection.Ascending ? 1 : -1
        }
        else if (sortType === SortType.Date) {
            return this.veriDate.sort(data1, data2, sortDirection);
        }
        else if (sortType === SortType.Number) {
            const direction = sortDirection === SortDirection.Ascending ? -1 : 1;

            if (typeof data1 === "string") {
                return direction;
            }

            return data1 < data2 ? 1 * direction : -1 * direction;
        }
        else if (sortType === SortType.Boolean) {
            const direction = sortDirection === SortDirection.Ascending ? -1 : 1;

            return data1 && !data2 ? 1 * direction : -1 * direction;
        }
        else {
            return sortDirection === SortDirection.Ascending
                ? data1.localeCompare(data2)
                : data2.localeCompare(data1);
        }
    }
}
